import { SimpleFileFragment, SimpleFileFragmentType } from '@common/graphql';
import { gql } from '@common/hooks';

export const DetailItemAttachments = gql`
  fragment DetailItemAttachments on DetailItemAttachment {
    id
    canUpdate {
      value
    }
    canDelete {
      value
    }
    expirationDate
    expired
    status
    statusChangedAt
    file {
      id
      ...SimpleFileFragment
    }
  }
  ${SimpleFileFragment}
`;

export const DetailItemGroupedAttachments = gql`
  fragment DetailItemGroupedAttachments on GroupedAttachments {
    approved {
      id
      ...DetailItemAttachments
    }
    rejected {
      id
      ...DetailItemAttachments
    }
    submitted {
      id
      ...DetailItemAttachments
    }
  }
  ${DetailItemAttachments}
`;

export type DetailItemAttachmentType = {
  canUpdate: {
    value: boolean;
  };
  canDelete: {
    value: boolean;
  };
  expirationDate?: string;
  expired: boolean;
  file: SimpleFileFragmentType;
  id: string;
  status: string;
  statusChangedAt: string;
};

export type GroupedAttachmentsType = {
  approved: DetailItemAttachmentType[];
  rejected: DetailItemAttachmentType[];
  submitted: DetailItemAttachmentType[];
};
